import { render, staticRenderFns } from "./SalespersonRulesAndFaqs.vue?vue&type=template&id=1e176972"
import script from "./SalespersonRulesAndFaqs.vue?vue&type=script&lang=js"
export * from "./SalespersonRulesAndFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports